module.exports = __webpack_public_path__ + "assets/img/img_2_9_1.95dd0456.png";